// extracted by mini-css-extract-plugin
export default {"notesListBlock":"QCeeMQpH2ddkrTfx_AAt"};